
const reducer = (state, action) => {
    switch (action.type) {
        //Change the player count
        case 'CHANGE_COUNT':
            let i;
            let newPlayers = [];
            for (i = 0; i < action.payload; i++)
                newPlayers.push({ name: '', class: '', voteCount: 0, life: false})
            return { ...state, players: newPlayers }
        
        //Change the vampire count
        case 'CHANGE_VAMPIRE_COUNT':
            return { ...state, vampireCount: action.payload }
        
        //Change player names
        case 'CHANGE_NAME':
            state.players[action.payload.index].name = action.payload.name
            return { ...state }
        
        //Turn the classes on and off
        case 'HANDLE_CLASS':
            if (action.payload === 'doctor')
                if (state.doctorCount === 1)
                    state.doctorCount = 0;
                else
                    state.doctorCount = 1;
            else if (action.payload === 'deadfucker')
                if (state.deadFuckerCount === 1)
                    state.deadFuckerCount = 0;
                else
                    state.deadFuckerCount = 1;
            else if (action.payload === 'werewolf')
                if (state.werewolfCount === 1)
                    state.werewolfCount = 0;
                else
                    state.werewolfCount = 1;
            else if (action.payload === 'darkmatter')
                if (state.darkMatterCount === 1)
                    state.darkMatterCount = 0;
                else
                    state.darkMatterCount = 1;
            
            
            return {...state}
        
        //Randomly attain vampire or villager trait to the players 
        case 'START_GAME':
            let currVampireCount = 0;
            let currDeadFuckerCount = 0;
            let currDoctorCount = 0;
            let currWerewolfCount = 0;
            let currDarkMatterCount = 0;
            let set = true;
            while (set) {
                state.players.forEach(player => {
                    let randomNum = Math.floor(Math.random() * 7);
                    //If random number is equal to 1 or 5, player becomes vampire
                    if (randomNum == 1 || randomNum == 5) {
                        currVampireCount += 1;
                        if (currVampireCount < parseInt(state.vampireCount) + 1) {
                            if (randomNum == 1)
                                player.class = 'vampire';
                            else 
                                player.class = 'foolvampire';        
                        }else {
                            player.class = 'villager';
                            currVampireCount = currVampireCount - 1; }
                    //If random number is equal to 2, player becomes dead fucker
                    } else if (randomNum == 2) {
                        currDeadFuckerCount += 1;
                        if (currDeadFuckerCount < parseInt(state.deadFuckerCount) + 1)
                            player.class = 'deadfucker'
                        else {
                            player.class = 'villager';
                            currDeadFuckerCount = currDeadFuckerCount - 1;
                        }
                    //If random number is equal to 3, player becomes doctor
                    } else if (randomNum == 3) {
                        currDoctorCount += 1;
                        if (currDoctorCount < parseInt(state.doctorCount) + 1) {
                            player.class = 'doctor';
                        }else {
                            player.class = 'villager';
                            currDoctorCount = currDoctorCount - 1;
                        }
                    //If random number is equal to 4, player becomes werewolf
                    } else if (randomNum == 4) {
                        currWerewolfCount += 1;
                        if (currWerewolfCount < parseInt(state.werewolfCount) + 1) {
                            player.class = 'werewolf';
                        } else {
                            player.class = 'villager';
                            currWerewolfCount = currWerewolfCount - 1;
                        }
                    //If random number is equal to 6, player becomes dark matter
                    } else if (randomNum == 6) {
                        currDarkMatterCount += 1;
                        if (currDarkMatterCount < parseInt(state.darkMatterCount) + 1) {
                            player.class = 'darkmatter';
                        } else {
                            player.class = 'villager';
                            currDarkMatterCount = currDarkMatterCount - 1; }    
                    //If random number is not equal to any of above, player becomes a villager 
                    }else 
                        player.class = 'villager'
                });
                if (currVampireCount === parseInt(state.vampireCount) && currDeadFuckerCount === parseInt(state.deadFuckerCount) && currDarkMatterCount === parseInt(state.darkMatterCount) 
                    && currDoctorCount === parseInt(state.doctorCount) && currWerewolfCount === parseInt(state.werewolfCount)) {
                    set = false;
                } else { currVampireCount = 0; currDeadFuckerCount = 0; currDoctorCount = 0; currWerewolfCount = 0; currDarkMatterCount = 0;}    
            }
            return { ...state }
        
        //Wait for the next player to start
        case 'WAITING_SCREEN':
            return { ...state, waitingScreen: true }
        
        //Skip to next player and open voting screen if last players turn is past
        case 'NEXT_PLAYER':
            //Kill the most voted villager and open voting screen  
            if (action.payload + 1 === state.players.length && state.turns !== 0) {
                let remainingPlayers = [];
                let selectedVillager = null;
                let villagerVoteCount = 0;
                state.players.forEach(player => {
                    if (player.mark && !player.antiMark)
                        player.class = 'babywerewolf'
                    if (player.voteCount > villagerVoteCount) {
                        selectedVillager = player;
                        villagerVoteCount = player.voteCount;
                    } else if (player.voteCount === villagerVoteCount)
                        selectedVillager = null;
                });

                //Check if dead fucker guessed correct
                if (state.guess === selectedVillager) 
                    state.players.filter(player => player.class === 'deadfucker')[0].angel = true;
                
                //If someone is dead, check if he has life or angel which saves them from death
                if (selectedVillager) {
                    if (selectedVillager.life) {
                        state.deathStatement = 'No one is fucking dead!!';
                        remainingPlayers = state.players;
                        state.blood -= 1;
                    } else if (selectedVillager.angel) {
                        state.deathStatement = 'No one is fucking dead!!';
                        remainingPlayers = state.players;
                        selectedVillager.angel = false;
                        state.blood -= 1;
                    } else {
                        remainingPlayers = state.players.filter(player => player !== selectedVillager);
                        state.deathStatement = `${selectedVillager.name} is dead!!!`;
                        state.blood = 2;
                    }
                } else {
                    state.deathStatement = 'No one is fucking dead!!';
                    remainingPlayers = state.players;
                    state.blood -= 1;
                }
                //Check blood, if it's 0, vitaminless vampires die
                if (state.blood == 0 && state.players.filter(player => player.class === 'foolvampire')) {
                    state.deathStatement += 'Oh, by the way.All the vitaminless vampires left the village...'
                    remainingPlayers = state.players.filter(player => player.class !== 'foolvampire');
                }
                //Check if warrior has killed anyone
                remainingPlayers = remainingPlayers.filter(player => !player.slay)
                //Reset life and vote attributes
                state.players.forEach(player => { player.voteCount = 0; player.life = false });
                return {...state, waitingScreen: false, votingScreen: true,vote: false,guess: {},
                        index: 0, turns: state.turns + 1,stacks: state.stacks + 1, players: remainingPlayers}
                    
            }
            //First round no killing
            else if (action.payload + 1 === state.players.length) {
                state.players.forEach(player => { player.voteCount = 0; player.life = false });
                return {...state, index: 0, vote:false,voteFinishScreen:true, waitingScreen:false, turns: state.turns + 1}
            }
            //Before the last players turn
            else
                return { ...state, index: action.payload + 1,waitingScreen:false, vote: false }
          
        //Vote for a villager to kill
        case 'KILL_VOTE':
            state.players[action.payload].voteCount += 1; 
            return { ...state, vote: true }
        
        //Deadfucker trait
        case 'GUESS_DEATH':
            return { ...state, guess: state.players[action.payload], vote: true }
        
        //Doctor trait
        case 'GUARD_PLAYER':
            if (state.players[action.payload].class != 'deadfucker')
                state.players[action.payload].life = true;
            return { ...state, vote: true }
        
        //Werewolf trait
        case 'WEREWOLF_BITE':
            state.players[action.payload].mark = 'true';
            return { ...state, vote: true }
        
        //Dark Matter trait
        case 'TRANSFORM':
            state.players[action.payload.index].class = action.payload.trait;
            return { ...state, vote: true }
        
        //Dracula traits
        case 'RESET_BLOOD':
            return { ...state, blood: 2 }
        
        case 'ANTI_MARK':
            state.players[action.payload].antiMark = true;
            return { ...state }
        
        //Warrior Trait
        case 'SLAY_VAMPIRE':
            state.players[action.payload].slay = true;
            return { ...state, vote: true}

        //Get to the next voter
        case 'NEXT_VOTER':
            return { ...state, index: action.payload + 1, vote: false }
        
        //After votes are complete
        case 'FINISH_VOTE':
            //See who has the most votes
            let remainingPlayers = [];
            let maxVoteCount = 0;
            let selectedPlayer = null;
            state.players.forEach(player => {
                if (player.voteCount > maxVoteCount) {
                    maxVoteCount = player.voteCount;
                    selectedPlayer = player;
                } else if (player.voteCount === maxVoteCount)
                    selectedPlayer = null; });
            
            if (selectedPlayer) {
                remainingPlayers = state.players.filter(player => player !== selectedPlayer);
                state.deathStatement = `${selectedPlayer.name} has left the village!!!`;
            } else {
                state.deathStatement = 'Everyone stays!';
                remainingPlayers = state.players; }
            
            return {...state, index: 0, votingScreen: false, voteFinishScreen: true, players: remainingPlayers}
                
        //Start the next turn
        case 'NEXT_TURN':
            state.players.forEach(player => player.voteCount = 0);
            return {...state,vote: false, voteFinishScreen: false}
    }
}
export default reducer;